import { useAuthContext } from '@providers/AuthProvider';
import { Routes } from './components/Routes';

export const AuthenticatedNoOrgRoutes = () => {
  const { me } = useAuthContext();
  if (!me) {
    return null;
  }
  return <Routes />;
};
